import { useState } from "react";
import { MessageSquare } from "lucide-react";
import ReviewModal from "@/components/feedback/ReviewModal";

/**
 * ShareFeedbackButton — calm, non-intrusive entry point used in footer,
 * dashboard, account settings, and the sample report page. Opens the
 * general-feedback ReviewModal.
 */
export default function ShareFeedbackButton({
    variant = "link",
    sourceLocation = "footer",
    className = "",
    label = "Share feedback",
}) {
    const [open, setOpen] = useState(false);

    const base =
        variant === "primary"
            ? "bl-btn-primary"
            : variant === "secondary"
              ? "bl-btn-secondary"
              : "inline-flex items-center gap-1.5 text-sm text-bl-muted hover:text-bl-primary transition-colors";

    return (
        <>
            <button
                onClick={() => setOpen(true)}
                className={`${base} ${className}`}
                data-testid={`share-feedback-btn-${sourceLocation}`}
            >
                <MessageSquare className="w-3.5 h-3.5" />
                <span>{label}</span>
            </button>
            {open && (
                <ReviewModal
                    open={open}
                    onClose={() => setOpen(false)}
                    sourceLocation={sourceLocation}
                    defaultGeneral
                />
            )}
        </>
    );
}
